/**
 * EntitiesAggregateTabs: tab bar container for the entities scope aggregate view.
 *
 * Tabs: Overview | Summary | Detailed
 * Tab state is driven by the `tab` prop (from URL query param) and
 * changes are reported up via `onTabChange`.
 *
 * Overview renders GroupOverviewTab (the former group-scope snapshot), which
 * now folds the ByJurisdiction section into its own render (directly below
 * the Gross Revenue chart, dashboards round 2 part 2 layout) rather than
 * stacking it after the whole tab here.
 *
 * Uses function Foo(props) with body destructuring per 147f605 guard.
 */

import { GroupOverviewTab } from '../group/GroupOverviewTab';
import { EntitiesSummaryTab } from './EntitiesSummaryTab';
import { EntitiesDetailedTab } from './EntitiesDetailedTab';

var ENTITIES_TABS = [
  { key: 'overview', label: 'Overview' },
  { key: 'summary', label: 'Summary' },
  { key: 'detailed', label: 'Detailed' },
];

function EntitiesTabBar(props) {
  var activeTab = props.activeTab;
  var onTabChange = props.onTabChange;
  return (
    <div className="flex gap-1 bg-muted rounded-lg p-1 w-fit">
      {ENTITIES_TABS.map(function (t) {
        var isActive = activeTab === t.key;
        return (
          <button
            key={t.key}
            className={
              'px-5 py-2 text-sm font-semibold rounded-md transition-all ' +
              (isActive
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground')
            }
            onClick={function () { onTabChange(t.key); }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}

export function EntitiesAggregateTabs(props) {
  var tab = props.tab || 'overview';
  var onTabChange = props.onTabChange;

  return (
    <div className="space-y-6" data-testid="entities-aggregate-tabs">
      <EntitiesTabBar activeTab={tab} onTabChange={onTabChange} />

      {tab === 'overview' && (
        <div className="space-y-8">
          <GroupOverviewTab />
        </div>
      )}
      {tab === 'summary' && (
        <EntitiesSummaryTab />
      )}
      {tab === 'detailed' && (
        <EntitiesDetailedTab />
      )}
    </div>
  );
}

export { ENTITIES_TABS };
